"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../../..");
const tokens_1 = require("../../../../styles/tokens");
const TabsContext_1 = require("../../TabsContext");
const Tab_styles_1 = require("./Tab.styles");
const Tab = ({ text, tabId, onKeyDown, icon, badge, }) => {
    const { selectedTabId, setSelectedTabId } = (0, TabsContext_1.useTabs)();
    const isSelected = selectedTabId !== undefined && selectedTabId === tabId;
    const handleSelectTab = () => {
        setSelectedTabId && setSelectedTabId({ tabId, isUserSelect: true });
    };
    return (react_1.default.createElement(Tab_styles_1.StyledTabListItem, { role: "presentation", selected: isSelected },
        react_1.default.createElement(Tab_styles_1.StyledTabButton, { "aria-selected": isSelected, "aria-controls": tabId, onClick: isSelected ? undefined : handleSelectTab, role: "tab", type: "button", tabIndex: isSelected ? 0 : -1, id: tabId, onKeyDown: onKeyDown, selected: isSelected },
            icon && (react_1.default.createElement(Tab_styles_1.StyledTabIconWrapper, null,
                react_1.default.createElement(__1.Icon, { name: icon.name, rotation: icon.rotation, style: icon.style, colour: isSelected ? "night" : "metal", size: 3 }))),
            react_1.default.createElement(__1.Text, { variant: "label", as: "span", skinny: true, props: { style: { color: "currentColor" } } }, text),
            badge && (react_1.default.createElement(__1.Badge, { style: { marginLeft: tokens_1.SIZES[0.5] }, text: badge.text, radius: badge.radius, colour: badge.colour, theme: badge.theme, luminosity: badge.luminosity })))));
};
exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map